import axios from 'axios'
import {
  CampModel,
  ResponseCRUD,
  ResponseObject,
  ResponseObjectPaginated,
  ResponseObjectURL,
  TableResumen,
} from '../model'

const BASEURL = process.env.REACT_APP_DEV_API_CENTRAL_URL

export function getCamp(dto: CampModel, page: number) {
  return axios.post<ResponseObjectPaginated<CampModel[]>>(`${BASEURL}/camp/getAll/${page}`, dto)
}

export function getCampById(dto: any) {
  return axios.get<ResponseObject<CampModel>>(`${BASEURL}/camp/getInformationById?campId=${dto}`)
}

export function createCamp(dto: CampModel) {
  return axios.post<ResponseCRUD>(`${BASEURL}/camp/createCamp`, dto)
}

export function deleteCamp(dto: any) {
  return axios.delete<ResponseCRUD>(`${BASEURL}/camp/deleteCamp?id=${dto}`)
}

export function updateCamp(dto: CampModel) {
  return axios.put<ResponseCRUD>(`${BASEURL}/camp/updateCamp`, dto)
}

// INICIO ---- SERVICIOS MASIVE

export function downloadTemplateCamp() {
  return axios.post<ResponseObjectURL>(
    `${BASEURL}/camp/downloadTemplateBulkLoad_file`,
    {},
    {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      },
      responseType: 'arraybuffer',
    },
  )
}

export function uploadMasiveCamp(dto: any) {
  return axios.post<ResponseObjectPaginated<TableResumen[]>>(`${BASEURL}/camp/bulkLoad`, dto)
}

// FIN ---- SERVICIOS MASIVE
